

import React from 'react';

import {Modal, ModalHeader, ModalBody} from 'Components/Modal';

import { getRecordValue } from "Services/CmsHelpers";
import { RenderWYSIWYG } from "Components/Form/index";
import { faLinkedin, faYoutube, faSpotify } from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class SpeakerModel extends React.Component {
    /**
     * @var state
     */
    state = {
    };

    /**
     * @method renderItem
     * @return {JSX.Element}
     */
    renderItem = () => {
        const { speaker } = this.props;

        let thumbnail = getRecordValue(speaker, 'thumbnail');
        let title = getRecordValue(speaker, 'title');
        let content = getRecordValue(speaker, 'content');
        let company_thumbnail = getRecordValue(speaker, 'company_thumbnail');
        let company_name = getRecordValue(speaker, 'company_name');
        let linkedin = getRecordValue(speaker, 'linkedin');
        let youtube = getRecordValue(speaker, 'youtube');
        let spotify = getRecordValue(speaker, 'spotify');
        let website = getRecordValue(speaker, 'website');
        let job_title = getRecordValue(speaker, 'job_title');

        return (
            <div className="flex flex-col md:flex-row items-center justify-center h-full">
                {thumbnail && thumbnail.url && (
                    <div className="w-full md:w-1/2 min-h-[4rem] md:min-h-[670px] md:h-auto">
                        <img
                            src={thumbnail.url}
                            alt={title ?? ''}
                            className="h-full min-h-[4rem] md:min-h-[670px] w-full object-cover"
                        />
                    </div>
                )}
                <div className="p-10 w-full md:w-1/2 flex flex-col items-center md:items-start text-black">
                    <div className="text-2xl my-2 mb-6 text-center md:text-left font-bold">
                        {title}
                        <br />
                        <div className="font-medium text-center md:text-left text-base mt-2">
                            {job_title}{job_title && company_name ? ', ' : ''}{company_name ?? ''}
                        </div>
                    </div>
                    {content && (
                        <RenderWYSIWYG
                            content={content}
                            className="my-6 text-black!important text-lg!important text-left!important"
                        />
                    )}
                    <div className="flex justify-start gap-6 mt-4">
                        {linkedin && (
                            <a href={linkedin} target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faLinkedin} size="2x" className="text-app-speaker-blue" />
                            </a>
                        )}
                        {youtube && (
                            <a href={youtube} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faYoutube} size="2x" className="text-app-speaker-blue" />
                        </a>
                        )}
                        {spotify && (
                            <a href={spotify} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faSpotify} size="2x" className="text-app-speaker-blue" />
                        </a>
                        )}
                        {website && (
                            <a href={website} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faGlobe} size="2x" className="text-app-speaker-blue" />
                        </a>
                        )}
                </div>
            </div>
        </div>
        );
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {onClose, speaker} = this.props;

        return (
            <Modal titleClass="text-app-speaker-blue" onClose={onClose} className="bg-white max-w-screen-sm md:max-w-4xl text-app-speaker-blue p-0 relative px-0">
                <ModalHeader onClose={onClose} className="border-none absolute right-0" titleClassName="text-app-speaker-blue absolute right-0" />
                <ModalBody containerClassName="px-0 py-0">
                    <div className="flex flex-col items-center justify-center p-0">
                        <div className="">
                            { this.renderItem() }
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }
}
